import { Box, Typography } from '@mui/material';

import { Heading1, Heading2 } from '../../../components/Heading';

const TopBanner = () => {
  return (
    <Box
      sx={{
        background: '#141516',
      }}
    >
      <Box textAlign="center" px={4} py={6}>
        <Heading1>Final Step:</Heading1>
        <br />
        <Heading2>Schedule your intro battle!</Heading2>
      </Box>
      <Box sx={{ background: '#353A3E', textAlign: 'center' }} p={5}>
        <Typography sx={{ fontSize: { xs: 20, lg: 32 } }}>
          Your free trial code has been activated!
        </Typography>
        <Typography sx={{ fontSize: { xs: 16, lg: 24 } }}>
          Choose a date and time below for your intro battle. This code will expire soon and this
          location has very limited capacity. Schedule your exciting workout battle right away to hold your spot.
        </Typography>
      </Box>
    </Box>
  );
};

export default TopBanner;
